/**
 * Environment Configuration
 *
 * Centralized access to environment variables with fallbacks.
 * Uses Vite's import.meta.env which automatically loads:
 * - .env.development when running `npm run dev`
 * - .env.production when running `npm run build`
 */

export const config = {
  // API Configuration
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api.helloasilo.com',

  // Google Maps
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

  // hCaptcha
  hcaptchaSiteKey: import.meta.env.VITE_HCAPTCHA_SITE_KEY || '10000000-ffff-ffff-ffff-000000000001',

  // Environment info
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const;

// Log configuration in development
if (config.isDevelopment) {
  console.log('🔧 Environment Configuration:', {
    mode: config.mode,
    apiBaseUrl: config.apiBaseUrl,
    isDevelopment: config.isDevelopment,
  });
}
